import { GrSelect } from "@jnpmedi/grebob";
import { useOrganizationContext } from "@newHooks/context/organization/organization.context";
import { MyOrganizationWithMembers } from "@maven-rest/auth/Organization.dto";
import { compareBigintSafe } from "@maven-helper/functions/Misc.function";

interface OrganizationDropdownProps {
  selectedOrganizationId: bigint;
  organizations: MyOrganizationWithMembers[];
}

export function OrganizationDropdown({ selectedOrganizationId, organizations }: OrganizationDropdownProps) {
  const { changeOrganization } = useOrganizationContext();

  const items = convertDropdownItems(organizations);
  const selectedValue = items.find((item) => item.value === String(selectedOrganizationId))?.value;

  return (
    <GrSelect
      fieldStyle="normal"
      label={{
        flexDirection: "row",
        text: "Organization",
        gap: "8px",
      }}
      optionStyle="normal"
      options={items}
      placeholder="row"
      size="medium"
      variant="text"
      value={selectedValue}
      disabled={items.length <= 1}
      onChange={(_, value) => changeOrganization(value as string)}
    />
  );
}

const convertDropdownItems = (organizations: MyOrganizationWithMembers[]) =>
  organizations.map((organization) => {
    const owner = organization.members.find((member) => compareBigintSafe(member.user.id, organization.ownerUserId));

    return {
      value: String(organization.id),
      label: `${organization.name} ${owner ? `(${owner.user.name})` : ""}`,
    };
  });
